import * as AT from '../constants/actionTypes'

/**
 * User reducer
 * @param {*} state 
 * @param {*} action 
 */
function user(state = { users: [] }, action) {
	switch (action.type) {
		case AT.USER_LIST_LOADING_STARTED:
			return Object.assign({}, state, {
				isLoading: true,
				users: [],
				error: undefined
			})
		case AT.USER_LIST_LOADING_FAILED:
			return Object.assign({}, state, {
				isLoading: false,
				error: action.payload.error
			})
		case AT.USER_LIST_LOADING_FINISHED:
			return Object.assign({}, state, {
				isLoading: false,
				users: action.payload.users,
				error: undefined
			})			
		default:
			return state;
	}
}

export default user;